import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheResonance from "./sections/TheResonance";
import ElevatedSurfCulture from "./sections/ElevatedSurfCulture";
import CoreIntelligenceSuites from "./sections/CoreIntelligenceSuites";
import WhyChooseOurService from "./sections/WhyChooseOurService";
import QueenslandMoments from "./sections/QueenslandMoments";
import RequestAQuote from "./sections/RequestAQuote";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheResonance />
      <ElevatedSurfCulture />
      <CoreIntelligenceSuites />
      <WhyChooseOurService />
      <QueenslandMoments />
      <RequestAQuote />
      <Footer />
    </div>;
}